/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppVersionConfigEntity } from '../models/AppVersionConfigEntity';
import type { UpdateAppVersionConfigDto } from '../models/UpdateAppVersionConfigDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AppVersionService {
  /**
   * Lấy cấu hình phiên bản ứng dụng
   * API public cho mobile gọi khi mở app để lấy cấu hình warning/required update của Android và iOS. API này không yêu cầu đăng nhập vì có thể được gọi trước màn hình login.
   * @returns AppVersionConfigEntity Trả về cấu hình phiên bản ứng dụng hiện tại cho Android và iOS.
   * @throws ApiError
   */
  public static appVersionControllerGetAppVersionConfig(): CancelablePromise<AppVersionConfigEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/server-config/app-version',
    });
  }

  /**
   * Cập nhật cấu hình phiên bản ứng dụng
   * API dành cho admin cập nhật cấu hình warning/required update cho Android và iOS. Backend validate định dạng X.Y.Z, chuẩn hóa chuỗi rỗng thành 0.0.0 và đảm bảo requiredVersion không lớn hơn warningVersion.
   * @param requestBody
   * @returns AppVersionConfigEntity Trả về cấu hình phiên bản ứng dụng sau khi cập nhật thành công.
   * @throws ApiError
   */
  public static appVersionControllerUpdateAppVersionConfig(
    requestBody: UpdateAppVersionConfigDto,
  ): CancelablePromise<AppVersionConfigEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/server-config/app-version',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
